module.exports = __webpack_public_path__ + "img/oabot_shadow.2e10ddc.png";